<template>
  <div class='expand-button'>
    <div class='expand-button-header'>
      <slot name='header'/>
    </div>
    <div class='expand-button-body' v-show='expanded'>
      <slot name='body'/>
    </div>
  </div>
</template>

<script>
export default {
  props: ["expanded"],
  data() {
    return {
      bodyVisible: false
    };
  }
};
</script>

<style scoped lang='scss'>
.expand-button {
  border-radius: 4px;
  color: $primary;
  background: $gray-1;
}
.expand-button-header {
  display: flex;
  padding: 4px 12px;
  justify-content: space-between;
}
.expand-button-body {
  border-top: 1px solid $gray-4;
  height: 200px;
  padding: 4px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/expandButton.vue